import { render } from "./PuckSection.vue?vue&type=template&id=952bbe1c&scoped=true"
import script from "./PuckSection.vue?vue&type=script&lang=js"
export * from "./PuckSection.vue?vue&type=script&lang=js"

import "./PuckSection.vue?vue&type=style&index=0&id=952bbe1c&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-952bbe1c"]])

export default __exports__